import { createReducer, Action, on } from '@ngrx/store';
import { orderBy } from 'lodash-es';

import { ManagerActions } from './manager.actions';
import { ManagerState } from './manager.state';
import { defaultPaginator } from '../../features/shared/constants/default-values';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { AppActions } from '../app/app.actions';

export const initialState: ManagerState = {
  loading: false,
  paginator: {
    pageIndex: 0,
    pageSize: 10,
    pageSizeOptions: [10, 25, 50],
  },
  trafficLightsCalculated: false,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      ManagerActions.LoadListFail,
      ManagerActions.LoadModelFail,
      ManagerActions.CalculateListFail,
      (state, action) => ({
        ...state,
        loading: false,
        error: action.error,
      })
    ),
    on(ManagerActions.LoadList, (state) => ({
      ...state,
      loading: true,
      error: undefined,
      list: undefined,
    })),
    on(ManagerActions.CalculateList, (state) => ({ ...state, loading: true, error: undefined })),
    on(ManagerActions.LoadListSuccess, (state, action) => ({
      ...state,
      loading: false,
      list: orderBy(action.list, (m) => m.managerDisplayName?.toLowerCase(), 'asc').map((m) => ({
        ...m,
        transactionQualities: {},
      })),
    })),
    on(
      AppActions.LoadInitDataSuccess,
      (state, action): ManagerState => ({
        ...state,
        loading: false,
        list: orderBy(action.data.managers, (m) => m.managerDisplayName?.toLowerCase(), 'asc').map(
          (m) => ({
            ...m,
            transactionQualities: {},
          })
        ),
      })
    ),
    on(ManagerActions.CalculateListSuccess, (state, action) => ({
      ...state,
      loading: false,
      list: action.list,
      trafficLightsCalculated: true,
    })),
    on(ManagerActions.SetSort, (state, action) => ({
      ...state,
      sort: action.sort,
      paginator: defaultPaginator,
    })),
    on(ManagerActions.SetSearch, (state, action) => ({
      ...state,
      search: action.search,
      paginator: defaultPaginator,
    })),
    on(ManagerActions.ClearModifiers, (state) => ({
      ...state,
      sort: undefined,
      paginator: defaultPaginator,
      search: undefined,
    })),
    on(ManagerActions.SetPaginator, (state, action) => ({
      ...state,
      paginator: {
        ...state.paginator,
        pageIndex: action.page.pageSize === state.paginator.pageSize ? action.page.pageIndex : 0,
        pageSize: action.page.pageSize,
      },
    }))
  )
);

export function reducer(state: ManagerState | undefined, action: Action) {
  return featureReducer(state, action);
}
